
import $ from 'jquery';

//fromacl_basketcontents.gsk.tpl
const removeGsk = (gskItemInfoKey, gskArrayId, selfLink, basketIndex) =>{
    const deleteGskItem = "/index.php?cl=acl_basket_giftcard&fnc=removeGiftcard&gskiteminfokey="+ gskItemInfoKey +"&gskarrayid=" + gskArrayId;
    const deleteGskArticle = selfLink + "&amp;cl=basket&fnc=changebasket&bindex=" + basketIndex + "&am=0&gsk=1";
    return $.ajax({
        type: 'GET',
        url: deleteGskItem,
        success: function (response) {

            if ( response.includes( 'empty' ) ) {
                window.location.href = deleteGskArticle;
            }
            if ( response.includes( 'full' ) ) {
                window.location.href = "/warenkorb/";
            }
        }
    });
}

window.removeGsk = removeGsk;
export default removeGsk;